import get from 'lodash/get';

export default state => {
  const data = get(state, 'page.data.zone.bigram', null);
  return data && data.toLowerCase();
};
